import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { LandsidePage, useLandsideNavigationStore } from 'pinia/landside_navigation'
import { defineAsyncComponent } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideMain',
  setup(__props) {

const LandsideHomePage = defineAsyncComponent(() => import('vuecomponents/LandsideHomePage.vue'))
const LandsideProductPage = defineAsyncComponent(() => import('vuecomponents/LandsideProductPage.vue'))
const LandsideSubscriptionPage = defineAsyncComponent(() => import('vuecomponents/LandsideSubscriptionPage.vue'))

const landsideNavigationStore = useLandsideNavigationStore()
const { currentPage } = storeToRefs(landsideNavigationStore)

return { __sfc: true,LandsideHomePage, LandsideProductPage, LandsideSubscriptionPage, landsideNavigationStore, currentPage, LandsidePage }
}

})